export default __webpack_public_path__ + "static/media/design-notes.cfbcaef2.svg";